<template>
    <Messages v-bind:profile_uid="$route.params.profile_uid" v-bind:user_role="$route.params.user_role"/>
</template>

<script>
import Messages from "../../components/common/Messages.vue";
import { mapState } from "vuex";

export default {
    components: {
        Messages
    },
    props: {
        is_editable: {
            type: Boolean,
            default: false,
        },
        profile_uid: {
            type: String,
            default: null,
        },
        user_role: {
            typeof: String,
            default: null,
        }
    },
    computed: {
		...mapState({
			user: "user"
		}),
	},
    data() {
        return {
            is_editable: false,
        }
    }
}
</script>